<template>
    <div class="field field--multi-select">
        <div class="row collapse no-pad align-middle" v-if="helptext || label">
            <div class="columns shrink" v-if="helptext">
                <help-text :helptext="helptext"></help-text>
            </div>
            <div class="columns">
                <label v-if="label" :class="labelClasses">{{ label }}</label>
            </div>
        </div>
        <div class="row">
            <div class="columns">
                <div class="field--multi-select__content">
                    <h4
                        class="field--multi-select__heading"
                        :class="{
                            'field--multi-select__heading--active': showOptions,
                            'field--multi-select__heading--disabled': !hasOptions
                        }"
                        @click="toggleOptions()">
                        {{ selectedText }}
                    </h4>
                    <div
                        class="field--multi-select__options"
                        v-show="showOptions">
                        <header class="field--multi-select__search-header">
                            <input
                                type="search"
                                v-model="searchTerm"
                                placeholder="Filter by name"
                                class="field--multi-select__search">
                            <button
                                type="button"
                                class="field--multi-select__close"
                                @click="toggleOptions">
                                &times;
                            </button>
                        </header>
                        <div class="field--multi-select__lists">
                            <div class="field--multi-select__group">
                                <ul v-if="hasOptions">
                                    <li
                                        class="field--multi-select__option"
                                        v-for="option in filteredOptions">
                                        <input
                                            class="field--multi-select__checkbox"
                                            type="checkbox"
                                            :value="option.key"
                                            :checked="isChecked(option.key)"
                                            @change="updateValue"
                                            ref="multiSelectInput"
                                            :id="`chk_${option.key}`">
                                        <label
                                            :for="`chk_${option.key}`"
                                            class="field--multi-select__label">
                                            {{ option.label }}
                                        </label>
                                    </li>
                                </ul>
                                <p
                                    class="field--multi-select__not-available"
                                    v-else>
                                    N/A
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    /**
     * Component Dependencies
     */
    import SelectField from './SelectField'
    import HelpText from '../HelpText'

    /**
     * Multi-Select Field Component
     */
    export default {
        name: 'multi_select_field',
        extends: SelectField,
        components: {
            HelpText
        },
        props: {},
        data () {
            return {
                searchTerm: '',
                showOptions: false
            }
        },
        methods: {
            toggleOptions () {
                this.showOptions = !this.showOptions
            },
            isChecked (key) {
                return this.value.includes(key)
            },
            updateValue (e) {
                let payload = this.value
                let existingIndex = payload.indexOf(e.target.value)
                existingIndex > -1
                    ? payload.splice(existingIndex, 1)
                    : payload.push(e.target.value)
                this.$emit('updated', payload)
            }
        },
        watch: {
            toggleOptions (toggled) {
                if (toggled) {
                    this.$refs.multiSelectInput.focus()
                }
            }
        },
        computed: {
            selectedText () {
                if (this.value) {
                    return this.value.length > 0
                        ? this.value.length + ' selected'
                        : '-- Select --'
                }
                return '-- Select --'
            },
            filteredOptions () {
                return this.options.filter(item => {
                    return item.label.toLowerCase().includes(this.searchTerm.toLowerCase())
                })
            },
            hasOptions () {
                return this.filteredOptions.length > 0
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/forms/MultiSelectField.vue